/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import React, {useState, useRef} from "react";
import {PiHandSwipeLeftThin} from "react-icons/pi";

interface FeatureItem {
    icon: React.ReactNode;
    text: string;
}

interface AppFeaturesProps {
    featureItems: FeatureItem[];
}

const AppFeatures: React.FC<AppFeaturesProps> = ({featureItems}) => {
    const [showSwipeIcon, setShowSwipeIcon] = useState(true);
    const scrollRef = useRef<HTMLDivElement | null>(null);

    const handleScroll = () => {
        if (scrollRef.current && scrollRef.current.scrollLeft > 5) {
            setShowSwipeIcon(false);
        } else {
            setShowSwipeIcon(true);
        }
    };

    return (
        <div className="relative mb-10">
            <div
                ref={scrollRef}
                onScroll={handleScroll}
                className="no-scrollbar -ml-5 -mr-5 md:ml-0 md:mr-0 mt-10 md:mt-0 relative flex overflow-scroll"
            >
                {featureItems.map((item, index) => (
                    <div key={index} className="pl-2 pr-2 md:pr-4 md:pl-0 min-w-[240px]">
                        <div className="rounded-2xl pt-8 pb-8 h-full bg-white min-h-[160px]">
                            {item.icon}
                            <div className="text-center xl:max-w-[240px] mx-auto text-sm px-6 mt-2">
                                {item.text}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {showSwipeIcon && (
                <PiHandSwipeLeftThin
                    className="font-thin swipe-left-right text-6xl absolute left-0 -bottom-10 text-mono-1000"/>
            )}
        </div>
    );
};

export default AppFeatures;
